import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../index';



export default function FieldValue({ children, className, style, label, error, footnote }) {
  return (
    <div className={`form-field focus ${className}`} style={style}>
      <Label type="form">{label}</Label>
      {children}
      {footnote && (
        <div className="form-field-footnote">{footnote}</div>
      )}
      <div className="error">{error || '\u00A0'}</div>
    </div>
  );
}

FieldValue.defaultProps = {
  style: {},
  className: '',
  error: null,
  footnote: null,
};

FieldValue.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape(),
  label: PropTypes.string.isRequired,
  error: PropTypes.node,
  footnote: PropTypes.node,
};
